import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { keyframes } from '@mui/material/styles';

const DOT_SIZE = 12;
const DOT_STEP = 1.5;
const DURATION = '1s';
const DELAY = -0.16;

const grow = keyframes`
  from {
    transform: scale(0.5);
  }
  to {
    transform: scale(1);
  }
`;

const styles = {
  loader: ({ palette }) => ({
    willChange: 'transform',
    position: 'relative',
    display: 'inline-block',
    width: `${DOT_SIZE}px`,
    height: `${DOT_SIZE}px`,
    borderRadius: '50%',
    backgroundColor: palette.colors.darkBlue,
    animation: `${grow} ${DURATION} ease-in-out infinite alternate both`,
    animationDelay: `${DELAY * 2}s`,
    '&::before, &::after': {
      content: '""',
      willChange: 'transform',
      position: 'absolute',
      top: 0,
      width: `${DOT_SIZE}px`,
      height: `${DOT_SIZE}px`,
      borderRadius: '50%',
      backgroundColor: palette.colors.darkBlue,
      animation: `${grow} ${DURATION} ease-in-out infinite alternate`,
    },
    '&::before': {
      left: `${-DOT_SIZE * DOT_STEP}px`,
      animationDelay: `${DELAY}s`,
    },
    '&::after': {
      left: `${DOT_SIZE * DOT_STEP}px`,
      animationDelay: `${DELAY * 3}s`,
    },
  }),
  dark: {
    display: 'flex',
    justifyContent: 'center',
    margin: '0 auto',
  },
};

const Loader = ({ variant = '' }) => {
  return <Box sx={[styles.loader, variant === 'dark' && styles.dark]} />;
};

Loader.propTypes = {
  variant: PropTypes.string,
};
export default Loader;
